// Experimental feature switches. Each gates a feature we may need to exclude
// from a final build: flip the flag to false and the UI disappears (backend
// routes stay, but nothing calls them).

// Card 102 — "Generate from my site" branding scan in TipDirect Setup.
export const EXPERIMENTAL_GENERATE_BRAND_FROM_SITE = true;

// Card Un67ehPJ — "Import from your website" tour autofill in CreateTourModal.
// On for every operator: the scan only ever produces a draft the operator edits
// before saving, so the switch is here as a kill-switch, not a whitelist.
export const EXPERIMENTAL_IMPORT_TOUR_FROM_URL = true;

// Card Y5QiKDCL — the "AI Readiness" benchmark module at the top of Setup. On
// for every operator (Andy's call): it only reads the operator's own public
// site and reports back. Turning it off also stops the weekly agent-summary re-audit from ever having a URL to crawl,
// since the Setup scan is what records one.
export const EXPERIMENTAL_AI_READINESS_BENCHMARK = true;
